import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrBreadcrumbComponent } from './pr-breadcrumb.component';
import { PrIconModule } from '../pr-icon/pr-icon.module';

@NgModule({
  declarations: [PrBreadcrumbComponent],
  imports: [CommonModule, PrIconModule],
  exports: [PrBreadcrumbComponent],
})
export class PrBreadcrumbModule {}
